module.exports = __webpack_public_path__ + "img/visa.c4bd375e.png";